import request from '@/utils/request'



// 获取充值信息 
export function getNotice(pageNum) {
    return request({
    url: '/api/message/officialList',
    method: 'get',
    params: {
      pageNum
    }
  })
}

// 审核充值记录
export function addNotice(data) {
  return request({
    url: '/api/message/officialAdd',
    method: 'post',
    data: data
  })
}
